import React, { useMemo } from 'react';

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { number, t } from '~/helpers';

function fieldValue(value) {
  return value || '';
}

function ReadOnlyField({ label, value, multiline }) {
  return (
    <TextField
      label={label}
      value={fieldValue(value)}
      variant="outlined"
      fullWidth
      size="small"
      multiline={multiline}
      rows={multiline ? 2 : 1}
      InputLabelProps={{ shrink: true }}
      InputProps={{ readOnly: true }}
    />
  );
}

function getDescricaoEstoque(item) {
  if (!item) return '';
  if (item.estoqueAreiaVO) {
    return (
      item.estoqueAreiaVO.descricaotipoareia ||
      item.estoqueAreiaVO.nomepostotipoareia
    );
  }
  return item.descricaotipoareia || item.nomepostotipoareia;
}

export default function View({ data }) {
  const itens = data?.itens || [];

  const totalPesoItens = useMemo(
    () =>
      itens.reduce(
        (total, item) =>
          total + Number(item.pesototalkgtransferenciaareiasiloitem || 0),
        0
      ),
    [itens]
  );

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: '100%',
        margin: 0,
        padding: 8,
      }}
    >
      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.configuracao.terminal.nomeposto')}
          value={data?.codigonomeposto || data?.idposto}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.operacao.transferenciaareiasilo.silo')}
          value={
            data?.nomesilotransferenciaareiasilo ||
            data?.descricaosilotransferenciaareiasilo
          }
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.operacao.transferenciaareiasilo.datahora')}
          value={data?.datahoratransferenciaareiasilo}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.menu.operacao.turno')}
          value={data?.numeroturno || data?.idturno}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={`${t('s.geral.pesototal')} Kg`}
          value={number(data?.pesototalkgtransferenciaareiasilo || totalPesoItens, '2')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.geral.executante')}
          value={
            data?.nomeusuariotransferenciaareiasilo ||
            data?.idusuariotransferenciaareiasilo
          }
        />
      </Grid>

      <Grid item xs={12}>
        <ReadOnlyField
          label={t('s.geral.observacao')}
          value={data?.observacaotransferenciaareiasilo}
          multiline
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle1">
          {t('s.operacao.transferenciaareiasilo.itens')}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Paper variant="outlined">
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <Table size="small" style={{ minWidth: 560 }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {t('s.operacao.transferenciaareiasilo.saco')}
                  </TableCell>
                  <TableCell align="right">{t('s.geral.sacos')}</TableCell>
                  <TableCell align="right">
                    {t('s.geral.pesototal')} Kg
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itens.map((item) => (
                  <TableRow
                    key={
                      item.idtransferenciaareiasiloitem ||
                      item.idpostotipoareiasaco
                    }
                  >
                    <TableCell>{getDescricaoEstoque(item)}</TableCell>
                    <TableCell align="right">
                      {number(
                        item.quantidadesacostransferenciaareiasiloitem || 0,
                        '2'
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {number(
                        item.pesototalkgtransferenciaareiasiloitem || 0,
                        '2'
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell>
                    <strong>{t('s.geral.total')}</strong>
                  </TableCell>
                  <TableCell align="right" />
                  <TableCell align="right">
                    <strong>{number(totalPesoItens, '2')}</strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
};

View.defaultProps = {
  data: {},
};

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multiline: PropTypes.bool,
};

ReadOnlyField.defaultProps = {
  value: '',
  multiline: false,
};
